import { isSuperUser } from "@saleor/auth/misc";
import {
  dispatchHistoryListUrl,
  DispatchListUrlQueryParams
} from "@saleor/dispatch/url";
import useNavigator from "@saleor/hooks/useNavigator";
import useUser from "@saleor/hooks/useUser";
import { masterFulfillmentPath, orderPath } from "@saleor/motherOrders/urls";
import { canViewMasterFulfillment } from "@saleor/utils/handlers/userHandler";
import { generatePdf } from "@saleor/utils/pdf/handler";
import * as React from "react";

import TripInformationDetailsPage from "./../../components/TripInformationDetailsPage";
import { useTripInformationList } from "./../../queries";

interface TripInformationProps {
  id: string;
  params: DispatchListUrlQueryParams;
}

const TripInformation: React.FC<TripInformationProps> = ({ id }) => {
  const navigate = useNavigator();
  const { user } = useUser();
  const enableViewMasterFulfillment = canViewMasterFulfillment();

  const handleBack = () => navigate(dispatchHistoryListUrl());

  const { data, loading } = useTripInformationList({
    displayLoader: true,
    variables: {
      id
    }
  });

  const generateTripTicket = async () => {
    generatePdf(data?.riderDispatchBatch, "/generate-trip-ticket");
  };

  const navigateUrl =
    enableViewMasterFulfillment && !isSuperUser(user)
      ? masterFulfillmentPath
      : orderPath;

  return (
    <TripInformationDetailsPage
      onBack={handleBack}
      tripInformation={data?.riderDispatchBatch}
      loading={loading}
      navigate={navigate}
      navigateUrl={navigateUrl}
      generateTripTicket={generateTripTicket}
    />
  );
};

export default TripInformation;
